
import React from 'react';

export default function WhatsAppButton() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/34609936590', '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 z-50 flex items-center justify-center w-14 h-14"
      aria-label="Contactar por WhatsApp"
    >
      <i className="fab fa-whatsapp text-2xl"></i>
    </button>
  );
}
